import { useCallback } from 'react';

import { UpdateAccountProfileReq } from '#/api/account';

import { AsyncResult } from '#/utils/types';

import { UsernameFormView } from './username-form-context-view';
import { useAccountProfileActions } from './account-profile-context';

export interface UsernameFormService {
  readonly submit: () => AsyncResult<void>;
}

export function useSubmit(
  formView: UsernameFormView,
): UsernameFormService['submit'] {
  const accountProfileActions = useAccountProfileActions();

  const submit = useCallback(async () => {
    if (!formView.canSubmit) throw new Error('Submit should be disabled');
    const result = await accountProfileActions.update(prepareRequest(formView));
    return result;
  }, [accountProfileActions, formView]);

  return submit;
}

function prepareRequest(formView: UsernameFormView): UpdateAccountProfileReq {
  return {
    username: formView.values.username,
    is_username_private: formView.values.isUsernamePrivate,
  };
}
